<template>
  <b-row>
    <b-col md="12">
      <component-new-header
        title="Project Manager"
        :isLoading="loading"
        :hasSearch="false"
        :hasReload="false"
        createButtonText="Add New Manager"
        @back-press="$router.push({ name: 'promo-create' })"
      />
    </b-col>
    <b-col md="12">
        <b-card class="card-wrap">
          <b-table
            :borderless="borderless"
            responsive="lg"
            :items="criteriaList"
            :fields="tenantColumns"
            thead-class="header"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <!-- <template slot="createdAt" slot-scope="data">
              <div>{{ data.item.createdAt | formatedate }}</div>
            </template>
            <template slot="action" slot-scope="data">
              <div class="d-flex">
                <div>
                  <b-button
                    :disabled="data.item.status == 'PENDING'"
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="primary"
                    @click="downloadDetails(data.item)"
                  >
                    <i class="fa fa-download"></i>
                  </b-button>
                </div>
                <div>
                  <b-button
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="primary"
                    @click="viewCriteria(data.item)"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </div>

                <div>
                  <b-button
                    v-if="$currentUserData.role == 'Tenant'"
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="danger"
                    @click="deleteCriteria(data.item)"
                  >
                    <i class="fa fa-trash bin"></i>
                  </b-button>
                </div>
              </div>
            </template> -->
          </b-table>
      </b-card>
      <div style="float: right">
        <i class="fa fa-regular fa-ellipsis">...</i>
          <!-- <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination> -->
        </div>
    </b-col>
  </b-row>
</template>

<script>
import ComponentNewHeader from "@/components/componentNewHeader";

export default {
  components: {
    ComponentNewHeader,
  },
  data() {
    return {
      loading: false,
      borderless: true,
      tenantColumns: [
        {
          key: "name",
          label: "Name",
        },
        {
          label: "Properties Assigned",
          key: "properties",
        },
        {
          label: "Phone No.",
          key: "phone",
        },
        {
          label: "Email",
          key: "email",
        },
        {
          label: "State",
          key: "state",
        },
        {
          key: "action",
        },
      ],
      criteriaList:[
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
        {
            name: "Benjimin Alex",
            properties:[
                "Property Name 1",
                "Property Name 2",
                "Property Name 3",
            ],
            phone:"+1 234675567",
            email:"Benjimaim_123@mail.com",
            state:"Florida"
      },
    ]
    }
  }
};
</script>

<style scoped>
.card-wrap {
  border-radius: 12px;
}

</style>
